import React from 'react';
import { TemplatesList } from '../../../../enums/TemplatesList';
import DefaultInfoSection from '../../../Templates/DefaultTemplate/Sections/HomePage/InfoSection/InfoSection';
import { Section } from '../../../../interfaces/Section';
import ModernInfoSection from '../../../Templates/ModernTemplate/Sections/HomePage/InfoSection/InfoSection';

export interface InfoSectionProps extends Section {
  aboutText: string;
  avatar?: string;
  phone: string;
  email: string;
}

const InfoSection = (props: InfoSectionProps) => {
  if (props.template === TemplatesList.MODERN) {
    return <ModernInfoSection {...props} />;
  }
  return <DefaultInfoSection {...props} />;
};

export default InfoSection;
